import moment from "moment";
export default {
    props: ['chartdata', 'date-range'],
    data() {
        return {
            date_range: [],
            async_dates: [],
            async_data: [],
        }
    },
    computed: {
        current_range() {

            if (this.date_range && this.date_range[0] && this.date_range[1]) {
                return this.date_range.join(" - ")
            }
            return ""
        }
    },
    mounted() {
        let data = this.chartdata;
        /*data = data.sort(function (d1, d2) {
            let m1 = moment(d1.date);
            let m2 = moment(d2.date);
            if (m1.isBefore(m2)) return -1;
            if (m1.isSame(m2)) return 0;
            if (m1.isAfter(m2)) return 1;
        });*/
        this.async_dates = this.chartdata.map((d) =>
            moment(d.inserted_at).format("ddd Do MMM hh:mm:ss")
        );
        this.async_data = this.chartdata.map((d) => Math.floor(parseFloat(d.balance)));

        this.date_range = (this.dateRange || "").split(" - ")
        this.showChart()
    },
    methods: {
        applyFilter() {
            this.$nextTick(() => {
                document.getElementById("filter-form").submit()
            })
        },
        showChart() {
            Highcharts.chart('graph', {
                title: { text: 'Transactions Summary' },
                xAxis: {
                    type: 'datetime',

                    title: {
                        text: 'Date'
                    },
                    categories: this.async_dates,
                },
                yAxis: {

                    title: { text: 'Account Balance' },
                    min: 0
                },
                legend: { layout: 'vertical', align: 'right', vertical_align: 'middle' },
                plotOptions: {
                    spline: {
                        marker: {
                            enabled: true
                        }
                    }
                },
                series: [
                    {
                        name: 'Account Balance',
                        //data: this.chartdata || []
                        data: this.async_data
                    }
                ],
                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: 500
                        },
                        chartOptions: {
                            legend: {
                                layout: 'horizontal',
                                align: 'center',
                                verticalAlign: 'bottom'
                            }
                        }
                    }]
                }
            })
        }
    }
}